module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_14.bbbae483.png";